const producers = [
  {
    id: 'productivity',
    label: 'Productivity',
    permission: 'VIEW_PRODUCTIVITY',
    dependencies: ['nitrogen', 'corn', 'starterFertilizer'],
  },
  {
    id: 'nitrogenLoss',
    label: 'Nitrogen Loss',
    permission: 'VIEW_VR_N_RX',
    dependencies: ['nitrogen', 'soy', 'nitrogenProtectant', 'earlySeasonFungicide'],
  },
];

const consumers = [
  {
    id: 'corn',
    label: 'Corn Rx',
    permission: 'VIEW_CORN_RX',
  },
  {
    id: 'soy',
    label: 'Soy Rx',
    permission: 'VIEW_SOY_RX',
  },
  {
    id: 'nitrogen',
    label: 'N Rx',
    permission: 'VIEW_VR_N_RX',
  },
  {
    id: 'lpk',
    label: 'LPK',
    permission: 'VIEW_SOIL_FERTILITY_SUITE',
  },
  {
    id: 'nitrogenProtectant',
    label: 'N Protectant',
    permission: 'VIEW_N_PROTECTANT_RX',
  },
  {
    id: 'earlySeasonFungicide',
    label: 'Early Season Fungicide',
    permission: 'VIEW_FUNGICIDE_SUITE',
  },
  {
    id: 'starterFertilizer',
    label: 'Starter Fertilizer',
    permission: 'VIEW_STARTER',
  },
];

export const modules = [
  ...producers.map((module) => ({ ...module, producer: true })),
  ...consumers.map((module) => ({
    ...module,
    dependencies: producers.filter((p) => p.dependencies.includes(module.id)).map((p) => p.id),
  })),
];

export const crops = [
  { label: 'Corn', id: 'corn' },
  { label: 'Soybean', id: 'soy' },
  { label: 'Wheat', id: 'wheat' },
];

export * from './starter-fertilizer.js';
export * from './nitrogen-protectant.js';
export * from './lime.js';
export * from './phosphorus.js';
export * from './potassium.js';
export * from './early-season-fungicide.js';
